import { render } from "./WorkerTagNew.vue?vue&type=template&id=d698d61a"
import script from "./WorkerTagNew.vue?vue&type=script&lang=js"
export * from "./WorkerTagNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__